<template>
  <div class="text-start">
    <form @submit.prevent="onSubmitAsset" :method="method" :class="form_class" ref="asset_form" id="asset_form" novalidate>

      <div class="row mb-3">
        <h5>{{ asset_sub_type.name }} :: {{ asset_sub_type.type }}</h5>
      </div>

      <div class="row mb-3 justify-content-left">
        <div class="col-12">
          <button class="btn btn-primary btn-lg btn-block float-end" type="submit" id="submit">{{ $t("submit" )}}</button>
        </div>
      </div>

      <fieldset class="form-group border p-2">

        <div class="row">
          <div class="col-12">
            <label for="name" class="float-left mandatory">{{ $t("attributes.asset.name") }}</label>
            <div class="input-group">
              <input type="text" :value="asset.name" class="form-control" name="name" ref="name" @input="onUpdateFormParam" required>
              <div class="invalid-feedback text-left">{{errorMessagesFor('name')}}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <label for="description" class="float-left">{{ $t("attributes.asset.description") }}</label>
            <div class="input-group">
              <textarea :value="asset.description" class="form-control" name="description" ref="description" @input="onUpdateFormParam"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <label for="location_uuid" class="float-left">{{ $t("attributes.asset.location") }}</label>
            <div class="input-group">
              <select name="location_uuid" :value="asset.location_uuid" ref="location_uuid" class="form-select" @input="onUpdateFormParam">
                <option></option>
                <option v-for="location in all_locations" :key="location.uuid" :value="location.uuid">
                  {{ optionLocationName(location) }}
                </option>
              </select>
              <div class="invalid-feedback text-left">{{errorMessagesFor('location_uuid')}}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6">
            <label for="qty" class="float-left mandatory">{{ $t("attributes.asset.qty") }}</label>
            <div class="input-group">
              <input type="number" :value="asset.qty" class="form-control" name="qty" ref="qty" @input="onUpdateFormParam" required min="1" step="1">
              <div class="invalid-feedback text-left">{{errorMessagesFor('qty')}}</div>
            </div>
          </div>

          <div class="col-12 col-sm-6">
            <label for="tag" class="float-left">{{ $t("attributes.asset.tag")}}</label>
            <div class="input-group">
              <input type="text" :value="asset.tag" class="form-control" name="tag" ref="tag" id="tag"  @input="onUpdateFormParam">
              <div class="invalid-feedback text-left">{{errorMessagesFor('tag')}}</div>
            </div>
          </div>
        </div>

      </fieldset>

      <hr class="m-3">

      <fieldset class="border p-2">

        <legend class="float-none w-auto p-2 m-0">Name Plate</legend>

        <div class="row">
          <div class="col-12 col-sm-6">
            <label for="manufacturer" class="float-left">{{ $t("attributes.asset.manufacturer")}}</label>
            <div class="input-group">
              <input type="text" :value="asset.manufacturer" class="form-control" name="manufacturer" ref="manufacturer" id="manufacturer"  @input="onUpdateFormParam">
              <div class="invalid-feedback text-left">{{errorMessagesFor('manufacturer')}}</div>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <label for="model_num" class="float-left">{{ $t("attributes.asset.model_num")}}</label>
            <div class="input-group">
              <input type="text" :value="asset.model_num" class="form-control" name="model_num" ref="model_num" id="model_num"  @input="onUpdateFormParam">
              <div class="invalid-feedback text-left">{{errorMessagesFor('model_num')}}</div>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <label for="serial_num" class="float-left">{{ $t("attributes.asset.serial_num")}}</label>
            <div class="input-group">
              <input type="text" :value="asset.serial_num" class="form-control" name="serial_num" ref="serial_num" id="serial_num"  @input="onUpdateFormParam">
              <div class="invalid-feedback text-left">{{errorMessagesFor('serial_num')}}</div>
            </div>
          </div>
        </div>
      
      </fieldset>

      <hr class="m-3">
      
      <fieldset class="border p-2">

        <legend class="float-none w-auto p-2 m-0">Energy</legend>

        <div class="row">

          <div class="col-12 col-sm-6">
            <label for="energy_source_uuid" class="float-left mandatory">{{ $t("attributes.asset.energy_source") }}</label>
            <div class="input-group">
              <select name="energy_source_uuid" :value="asset.energy_source_uuid" ref="energy_source_uuid" class="form-select"  @input="onUpdateFormParam">
                <option></option>
                <option v-for="energy_source in energy_sources" :key="energy_source.uuid" :value="energy_source.uuid">
                  {{ energy_source.name }}
                </option>
              </select>
              <div class="invalid-feedback text-left">{{errorMessagesFor('energy_source_uuid')}}</div>
            </div>
          </div>        

          <div class="col-12 col-sm-6">
            <label for="meter_uuid" class="float-left">{{ $t("attributes.asset.meter") }}</label>
            <div class="input-group">
              <select name="meter_uuid" :value="asset.meter_uuid" ref="meter_uuid" class="form-select" @input="onUpdateFormParam">
                <option></option>
                <option v-for="meter in allMeters()" :key="meter.uuid" :value="meter.uuid">
                  {{ meter.num }}
                </option>
              </select>
              <div class="invalid-feedback text-left">{{errorMessagesFor('meter_uuid')}}</div>
            </div>
          </div>

          <div class="col-12 col-sm-6">
            <label for="energy_use_sub_cat_uuid" class="float-left mandatory">{{ $t("attributes.asset.energy_use_cat") }}</label>
            <div class="input-group">
              <select name="energy_use_sub_cat_uuid" :value="asset.energy_use_sub_cat_uuid" ref="energy_use_sub_cat_uuid" class="form-select"  @input="onUpdateFormParam">
                <option></option>
                <optgroup v-for="energy_use_cat in energy_use_cats" :key="energy_use_cat.uuid" :label="energy_use_cat.name">
                  <option v-for="energy_use_sub_cat in getEnergyUseSubCats(energy_use_cat.uuid)" :key="energy_use_sub_cat.uuid" :value="energy_use_sub_cat.uuid">
                    {{ energy_use_sub_cat.name }}
                  </option>
                </optgroup>
              </select>
              <div class="invalid-feedback text-left">{{errorMessagesFor('energy_source_uuid')}}</div>
            </div>
          </div>

          <div class="col-12 col-sm-6">
            <label for="power_cal_method" class="float-left mandatory">{{ $t("attributes.asset.power_cal_method") }}</label>
            <div class="input-group">
              <select name="power_cal_method" :value="asset.power_cal_method" ref="power_cal_method" class="form-select"  @input="onUpdateFormParam">
                <option></option>
                <option value="rated_input_power">{{ $t("attributes.asset.rated_input_power")}}</option>
                <option value="rated_output_power">{{ $t("attributes.asset.rated_output_power")}}</option>
              </select>
            </div>
          </div>

          <div class="col-12 col-sm-6">
            <label for="controls" class="float-left">{{ $t("attributes.asset.controls") }}</label>
            <div class="input-group">
              <select name="controls" :value="asset.controls" ref="controls" class="form-select"  @input="onUpdateFormParam">
                <option></option>
                <option value="local_control">{{ $t("attributes.asset.local_control")}}</option>
                <option value="central_control">{{ $t("attributes.asset.central_control")}}</option>
                <option value="manual_control">{{ $t("attributes.asset.manual_control")}}</option>
                <option value="none_control">{{ $t("attributes.asset.none_control")}}</option>
              </select>
            </div>
          </div>

        </div>

        <div class="row" v-if="byRatedInputPower">
          <div class="col-12">
            <label for="rated_input_power" class="float-left mandatory">{{ $t("attributes.asset.rated_input_power") }}</label>
            <div class="input-group">
              <input type="number" :value="asset.rated_input_power" class="form-control" name="rated_input_power" ref="rated_input_power" @input="onUpdateFormParam" min="0" step="any">
              <select name="rated_input_power_unit_code" :value="asset.rated_input_power_unit_code" ref="rated_input_power_unit_code" class="form-select"  @input="onUpdateFormParam">
                <option></option>
                <option v-for="power_unit in power_units" :key="power_unit" :value="power_unit.code">
                  {{ power_unit.code }}
                </option>
              </select>
              <div class="invalid-feedback text-left">{{errorMessagesFor('rated_input_power')}}</div>
              <div class="invalid-feedback text-left">{{errorMessagesFor('rated_input_power_unit_code')}}</div>
            </div>
          </div>
        </div>

        <div class="row" v-if="byRatedOutputPower">
          <div class="col-6">
            <label for="rated_output_power" class="float-left mandatory">{{ $t("attributes.asset.rated_output_power") }}</label>
            <div class="input-group">
              <input type="number" :value="asset.rated_output_power" class="form-control" name="rated_output_power" ref="rated_output_power" @input="onUpdateFormParam" min="0" step="any">
              <select name="rated_output_power_unit_code" :value="asset.rated_output_power_unit_code" ref="rated_output_power_unit_code" class="form-select" @input="onUpdateFormParam">
                <option></option>
                <option v-for="power_unit in power_units" :key="power_unit" :value="power_unit.code">
                  {{ power_unit.code }}
                </option>
              </select>
              <div class="invalid-feedback text-left">{{errorMessagesFor('rated_output_power')}}</div>
              <div class="invalid-feedback text-left">{{errorMessagesFor('rated_output_power_unit_code')}}</div>
            </div>
          </div>

          <div class="col-6">
            <label for="rated_efficiency_pcn" class="float-left mandatory">{{ $t("attributes.asset.rated_efficiency_pcn") }}</label>
            <div class="input-group">
              <input type="number" :value="asset.rated_efficiency_pcn" class="form-control" name="rated_efficiency_pcn" ref="rated_efficiency_pcn" @input="onUpdateFormParam" min="0" max="100" step="any">
              <span class="input-group-text">%</span>
              <div class="invalid-feedback text-left">{{errorMessagesFor('rated_efficiency_pcn')}}</div>
            </div>
          </div>
        </div>

      </fieldset>

      <hr class="m-3">

      <fieldset class="border p-2">

        <legend class="float-none w-auto p-2 m-0">Life Cycle</legend>

        <div class="row">
          <div class="col-6">
            <label for="installed_on" class="float-left">{{ $t("attributes.asset.installed_on")}}</label>
            <div class="input-group">
              <input type="date" :value="asset.installed_on" class="form-control" name="installed_on" ref="installed_on" id="installed_on"  @input="onUpdateFormParam">
              <div class="invalid-feedback text-left">{{errorMessagesFor('installed_on')}}</div>
            </div>
          </div>

          <div class="col-6">
            <label for="retired_on" class="float-left">{{ $t("attributes.asset.retired_on")}}</label>
            <div class="input-group">
              <input type="date" :value="asset.retired_on" class="form-control" name="retired_on" ref="retired_on" id="retired_on"  @input="onUpdateFormParam">
              <div class="invalid-feedback text-left">{{errorMessagesFor('retired_on')}}</div>
            </div>
          </div>

          <div class="col-6">
            <label for="life_cycle_length" class="float-left">{{ $t("attributes.asset.life_cycle_length") }}</label>
            <div class="input-group">
              <input type="number" :value="asset.life_cycle_length" class="form-control" name="life_cycle_length" ref="life_cycle_length" @input="onUpdateFormParam" min="0" step="any">
              <span class="input-group-text">{{ $t("years") }}</span>
              <div class="invalid-feedback text-left">{{errorMessagesFor('life_cycle_length')}}</div>
            </div>
          </div>

        </div>

      </fieldset>

      <hr class="m-3">

      <div class="row mb-3 justify-content-left">
        <div class="col-12">
          <button class="btn btn-primary btn-lg btn-block float-end" type="submit" id="submit">{{ $t("submit" )}}</button>
        </div>
      </div>

    </form>  
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue';
import { useStore } from 'vuex';
import { setFieldValidity } from '@/common/form_field_validation';
import { locationFullName } from '@/common/location_helpers';

export default {
  name: 'AssetForm',
  props: [
    "assetUuid",
    "assetSubTypeUuid",
    "siteUuid",
    "meterUuid",
    "locationUuid"
  ],
  emits: [
    "asset-updated",
    "asset-created"
  ],
  setup(props) {
    const store = useStore();

    let editingAsset
    let method
    let site_uuid
    let asset_sub_type 

    if (props.assetUuid) {
      //const store = useStore();
      editingAsset = store.getters.getAssetByUUID(props.assetUuid);
      site_uuid = ref(editingAsset.site_uuid); 
      asset_sub_type = store.getters.getAssetSubType(editingAsset.asset_sub_type_uuid);
      method = "POST"
    } else {
      site_uuid = ref(props.siteUuid);
      console.log("Inside assets/Form.vue, props.assetSubTypeUuid ==> ", props.assetSubTypeUuid);
      console.log("Inside assets/Form.vue, props.meterUuid ==> ", props.meterUuid);
      asset_sub_type = store.getters.getAssetSubType(props.assetSubTypeUuid);
      editingAsset = {
        uuid: null,
        site_uuid: site_uuid,
        //name: assetSubType.name,
        name: store.getters.nameForAsset(asset_sub_type),
        asset_sub_type_uuid: asset_sub_type.uuid,
        location_uuid: props.locationUuid,
        meter_uuid: props.meterUuid,
        description: null,
        qty: 1,
        energy_source_uuid: null,
        rated_input_power: null,
        rated_input_power_unit: null,
        rated_output_power: null,
        rated_output_power_unit: null,
        rated_efficiency_pcn: null
      }
      method = "PUT"
    }
    console.log("Inside assets/Form.vue, asset_sub_type ==> ", asset_sub_type);

    const energy_sources = store.getters.getAllEnergySources;
    const energy_use_cats = store.getters.getAllEnergyUseCats;
    const getEnergyUseSubCats = function(useCatUUID) {
      return store.getters.getEnergyUseSubCatsByUseCat(useCatUUID);
    }
    const all_locations = store.getters.getLocationsBySiteUUID(site_uuid.value);
    //const all_meters = store.getters.getMetersBySiteUUID(site_uuid);

    const asset = reactive(editingAsset); // reactive varable

    const power_units = store.getters.getUnitsByType("Unit::PowerUnit");

    const byRatedInputPower = ref(false); // reactive varable
    const byRatedOutputPower = ref(false); // reactive varable

    const setPowerCalculation = function() {
      byRatedOutputPower.value = false;
      byRatedInputPower.value = false;
      console.log("Inside views/assets/Form.vue setPowerCalculation(), asset.power_cal_method ==> ", asset.power_cal_method)
      if (asset.power_cal_method == 'rated_input_power') {
        byRatedInputPower.value = true;
      } else if (asset.power_cal_method == 'rated_output_power') {
        byRatedOutputPower.value = true;
      }
    }

    const setEnergySource = function() {
      if (asset.meter_uuid) {
        const meter = store.getters.getMeterByUUID(asset.meter_uuid);
        if (meter) {
          asset.energy_source_uuid = meter.energy_source_uuid
        }
      }
    }

    onMounted(function() {
      setPowerCalculation();
      setEnergySource();
    });

    return {
      asset,
      site_uuid,
      asset_sub_type,
      energy_sources,
      energy_use_cats,
      getEnergyUseSubCats,
      all_locations,
      //all_meters,
      method,
      power_units,
      byRatedInputPower,
      byRatedOutputPower,
      setFieldValidity,
      setPowerCalculation,
      setEnergySource
    }    
  },
  data() {
    return {
      form_class: 'needs-validation',
      form_errors: {}
      //assetUUID: null
    }
  },

  computed() {
  },

  methods: {
    onUpdateFormParam(e) {
      const fieldName = e.target.name;
      this.asset[fieldName] = e.target.value;
      setFieldValidity(this.$refs, fieldName, null);

      if (fieldName == "power_cal_method") {
        this.setPowerCalculation();
      }

      if (fieldName == "meter_uuid") {
        this.setEnergySource();
      }
    },
    validateForm() {
      const thisForm = this.$refs.asset_form;
      this.form_errors = {}; // reset form errors

      // use the browser's checkValidity function to validate the form.
      if (!thisForm.checkValidity()) {
      // then we gather the native error messages
        const inputFields = Array.from(thisForm.getElementsByTagName("input")).concat(Array.from(thisForm.getElementsByTagName("select")));
        const thisHandle = this;
        inputFields.forEach(function(input) {
          const paramName = input.name
          console.log(`Inside validateForm, input.validationMessage of ${paramName} ===> `, input.validationMessage);
          if (input.validationMessage.length > 0) {
            const paramName = input.name;
            thisHandle.form_errors[paramName] = input.validationMessage;
          }
        });
      }

      console.log("Inside assets/From.vue validateForm, this.form_errors ==> ", this.form_errors);

      // if this.form_errors are empty then the form is valid
      return this.isFormErrorFree(this.form_errors);
    },

    isFormErrorFree(form_errors) {
      return Object.values(form_errors).reduce(function(acc, val1) { 
        return ((val1 === null) || (val1.length === 0)) && acc 
      }, true);
    },    

    async onSubmitAsset() {
      if (this.validateForm()) {
        if (this.asset.uuid) {
          await this.$store.dispatch("modifyAsset", this.asset);
          this.$emit("asset-updated", { assetUUID: this.asset.uuid });
        } else {
          const newAssetUUID = await this.$store.dispatch("addAsset", this.asset);
          this.$emit("asset-created", { assetUUID: newAssetUUID });
        }        
      } else {
        console.log("Inside assets/From.vue onSubmitAsset, validateFrom not ok");
        this.form_class = 'was-validated';
        this.$forceUpdate(); // need this or error message may not appear
        return;
      }        
    },

    errorMessagesFor(fieldName) {
      if (this.$refs[fieldName]) {
        return this.$refs[fieldName].validationMessage
      }
    },

    optionLocationName(asset) {
      console.log("Inside assets/Form.vue, optionLocationName() locationFullName(asset) ==> ", locationFullName(asset));
      return locationFullName(asset).reduce(function(str, n) {
        return (str.length > 0) ? (str + " :: " + n) : n
      }, "");
    },

    allMeters() {
      const search_args = {
        site_id: this.site_uuid,
        energy_source_uuid: this.asset.energy_source_uuid
      }
      return this.$store.getters.searchMetersBy(search_args);
    }

  }
}
</script>